import { render, staticRenderFns } from "./AdministrationPageHeader.vue?vue&type=template&id=4e647a5a&"
import script from "./AdministrationPageHeader.vue?vue&type=script&lang=ts&"
export * from "./AdministrationPageHeader.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports